import styled from 'styled-components';

import {breakpoint} from 'theme';

export const HeaderControls = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap-reverse;
    gap: 1.5rem;

    @media (max-width: ${breakpoint.phone}) {
        margin-bottom: 20px;
    }
`;

export const NavigationWrapper = styled.div<{needMargin?: boolean}>`
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 0;
    max-width: 100%;
    flex: 1 1 auto;

    @media (max-width: ${breakpoint.phone}) {
        margin-bottom: ${(p) => (p.needMargin ? '20px' : '0')};
    }

    nav {
        flex-wrap: wrap;
        width: 100%;
        max-width: 100%;
        max-height: none;
        row-gap: 8px;

        a {
            white-space: nowrap;
        }
    }
`;

export const ControlsWrapper = styled.div`
    display: flex;
    gap: 0.8rem;
    @media (max-width: ${breakpoint.tablet}) {
        min-width: unset;
        flex-wrap: wrap;
        flex-grow: 1;
    }
`;
